/* src/app/components/cover-settings/tooltip-info-despagination/tooltip-info-despagination.component.scss */
h4 {
  font-size: 16px;
  color: #949494;
}
p {
  font-size: 22px;
  border-radius: 20px;
  padding: 10px;
  background-color: #f6f6f6;
}
/*# sourceMappingURL=tooltip-info-despagination.component-SY3MQZD3.css.map */
